import angular from 'angular';

import ComponentModule from './component';
import CalendarNavigationComponent from './calendar-navigation.cmpt';

export default angular
    .module('application.scene.authorized.scene.calendar.component.calendar-navigation', [
        ComponentModule.name
    ])
    .component(CalendarNavigationComponent.selector, CalendarNavigationComponent);



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/calendar/component/calendar-navigation/index.js